// Angular imports
import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';

// CC-Common imports
import { Utils } from 'cc-common';

// component imports
import { BoardApprovalBaseComponent } from '../../../board-approval/_base/board-approval-base.component';

// Model imports
import { CollectionsBoardApprovalDocumentResultDto } from '../../_models/collections-board-approval-document-result-dto';
import { CollectionsBoardApprovalDocumentRawDto } from '../../_models/collections-board-approval-document-raw-dto';
import { CollectionsBoardApprovalDocumentParameterDto } from '../../_models/collections-board-approval-document-parameter-dto';
import { CollectionsBoardApprovalParameterDto } from '../../_models/collections-board-approval-parameter-dto';
import { FileInfoDisplayResultDto } from '../../../_models/file-info-display-result-dto';

@Component({
    selector: 'app-collections-attachment-selector',
    templateUrl: './collections-attachment-selector.component.html',
    styleUrls: ['./collections-attachment-selector.component.scss']
})
export class CollectionsAttachmentSelectorComponent extends BoardApprovalBaseComponent implements OnInit {
    @Input() title = 'Manage Documents';
    @Input() visible = false;
    @Input() isViewOnly = false;
    @Input() customerId: string;
    @Input() communityId: number;
    @Output() onClose = new EventEmitter<void>();

    collectionDocuments: CollectionsBoardApprovalDocumentResultDto[];
    isAttachmentModified = false;

    constructor(protected readonly injector: Injector) {
        super(injector);
    }

    ngOnInit() {
        this.populateCollectionsDocuments();
    }

    closeCollectionAttachmentSelector(): void {
        this.visible = false;
        this.onClose.emit();
    }

    onAttachmentUpdate(allFiles: Array<any>): void {
        allFiles.forEach((file) => {
            if (Utils.notNullAndDefined(file['action'])) {
                const documentParams: CollectionsBoardApprovalDocumentRawDto =
                    new CollectionsBoardApprovalDocumentRawDto();
                documentParams.communityId = this.communityId;
                documentParams.customerId = this.customerId;
                if (Utils.notNullAndDefined(file.fileId)) {
                    documentParams.fileId = file.fileId;
                    if (Utils.notNullAndDefined(file.communityId)) {
                        documentParams.mode = Utils.notNullAndDefined(file.customerId) ? 'OWNER' : 'COMMUNITY';
                    }
                } else {
                    documentParams.mode = 'LOCAL';
                }
                documentParams.fileBase64String = Utils.notNullAndDefined(file.fileBase64String)
                    ? file.fileBase64String
                    : null;
                documentParams.fileName = Utils.notNullAndDefined(file.fileName) ? file.fileName : file.name;

                this.boardApprovalHelperService.showLoading();
                this.sharedBoardApprovalService.uploadCollectionDocument(documentParams).subscribe(
                    (result: any) => {
                        this.boardApprovalHelperService.hideLoading();
                        this.populateCollectionsDocuments(true);
                    },
                    (error) => {
                        this.errorService.displayError(error);
                        this.boardApprovalHelperService.hideLoading();
                        this.populateCollectionsDocuments(true);
                    }
                );
            }
        });
    }

    onDeleteFile(fileToBeDeleted: CollectionsBoardApprovalDocumentResultDto): void {
        const baseParams: CollectionsBoardApprovalDocumentParameterDto = this.getBoardDocumentParameter(
            fileToBeDeleted.fileId
        );
        this.boardApprovalHelperService.showLoading();
        this.sharedBoardApprovalService.deleteCollectionDocument(baseParams).subscribe(
            () => {
                this.populateCollectionsDocuments(true);
                this.boardApprovalHelperService.hideLoading();
            },
            (error) => {
                this.errorService.displayError(error);
                this.boardApprovalHelperService.hideLoading();
            }
        );
    }

    private getBoardDocumentParameter(fileStoreId: number): CollectionsBoardApprovalDocumentParameterDto {
        const baseParams: CollectionsBoardApprovalDocumentParameterDto =
            new CollectionsBoardApprovalDocumentParameterDto();
        baseParams.communityId = this.communityId;
        baseParams.customerId = this.customerId;
        baseParams.fileId = fileStoreId;
        baseParams.clearCache = true;
        return baseParams;
    }

    private populateCollectionsDocuments(clearCache = false): void {
        const baseParams: CollectionsBoardApprovalParameterDto = new CollectionsBoardApprovalParameterDto();
        baseParams.communityId = this.communityId;
        baseParams.customerId = this.customerId;
        baseParams.clearCache = clearCache;
        this.sharedBoardApprovalService.getCollectionDocuments(baseParams).subscribe(
            (results: FileInfoDisplayResultDto[]) => {
                this.collectionDocuments = results;
                this.boardApprovalHelperService.hideLoading();
            },
            (error) => {
                this.errorService.displayError(error);
                this.boardApprovalHelperService.hideLoading();
            }
        );
    }
}
